import { makeStyles } from '@material-ui/core';
import { distances } from '@setvi/shared/styles';

export const useStyles = makeStyles(({ palette, spacing }) => ({
  container: {
    backgroundColor: '#FAFAFB',
    padding: `${distances.px.base} ${distances.px.medium}`,
    display: 'flex',
    alignItems: 'center',
    gridGap: distances.px.medium,
    boxShadow:
      '0px 24px 48px -8px rgba(48, 54, 60, 0.12), 0px 4px 4px 0px rgba(48, 54, 60, 0.04)',
    borderRadius: 120
  },
  wrapper: {
    display: 'flex',
    alignItems: 'center'
  },
  count: {
    height: 24,
    minWidth: 24,
    borderRadius: 50,
    fontSize: 12,
    fontWeight: 600,
    lineHeight: '16px',
    marginRight: spacing(1),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: palette.primary.main,
    color: palette.common.white
  },
  button: {
    textDecoration: 'underline',
    color: palette.primary.main,
    padding: spacing(1)
  }
}));
